/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface DatasetColumnMappingOut
 */
export interface DatasetColumnMappingOut {
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingOut
   */
  columnName: string;
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingOut
   */
  jsonPath: string;
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingOut
   */
  datasetUuid: string;
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingOut
   */
  elementUuid: string;
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingOut
   */
  uuid: string;
}

/**
 * Check if a given object implements the DatasetColumnMappingOut interface.
 */
export function instanceOfDatasetColumnMappingOut(value: object): value is DatasetColumnMappingOut {
  if (!('columnName' in value) || value['columnName'] === undefined) return false;
  if (!('jsonPath' in value) || value['jsonPath'] === undefined) return false;
  if (!('datasetUuid' in value) || value['datasetUuid'] === undefined) return false;
  if (!('elementUuid' in value) || value['elementUuid'] === undefined) return false;
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  return true;
}

export function DatasetColumnMappingOutFromJSON(json: any): DatasetColumnMappingOut {
  return DatasetColumnMappingOutFromJSONTyped(json, false);
}

export function DatasetColumnMappingOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetColumnMappingOut {
  if (json == null) {
    return json;
  }
  return {
    columnName: json['column_name'],
    jsonPath: json['json_path'],
    datasetUuid: json['dataset_uuid'],
    elementUuid: json['element_uuid'],
    uuid: json['uuid']
  };
}

export function DatasetColumnMappingOutToJSON(value?: DatasetColumnMappingOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    column_name: value['columnName'],
    json_path: value['jsonPath'],
    dataset_uuid: value['datasetUuid'],
    element_uuid: value['elementUuid'],
    uuid: value['uuid']
  };
}
